import { Controller } from 'stimulus'
import Sortable from 'sortablejs'

export default class extends Controller {
  connect() {
    this.element.dataset.crmForecast = 'ready'
    this.element.querySelectorAll('.crm-forecast-body').forEach((col) => {
      Sortable.create(col, {
        group: {
          name: 'forecast',
          put: (to) => to.el.dataset.droppable === 'true'
        },
        animation: 150,
        draggable: '.crm-card',
        filter: '.crm-card--locked',
        preventOnFilter: false,
        ghostClass: 'crm-card--ghost',
        chosenClass: 'crm-card--chosen',
        revertOnSpill: true,
        onEnd: (e) => this.persist(e)
      })
    })
  }

  persist(e) {
    if (e.from === e.to) { this.refreshColumn(e.from); return }
    const id = e.item.dataset.oppId
    const month = e.to.dataset.month
    this.refreshColumn(e.from)
    this.refreshColumn(e.to)
    fetch(`/crm/opportunities/${id}/reschedule`, {
      method: 'PATCH',
      headers: this.headers(),
      body: JSON.stringify({ month })
    })
      .then((r) => { if (!r.ok) throw new Error('reschedule failed') })
      .catch(() => window.location.reload())
  }

  refreshColumn(col) {
    if (!col) return
    const cards = col.querySelectorAll('.crm-card')
    col.querySelector('[data-crm-empty]')?.classList.toggle('hidden', cards.length > 0)
    const lane = col.closest('[data-crm-lane]')
    if (!lane) return
    const countEl = lane.querySelector('[data-forecast-count]')
    if (countEl) countEl.textContent = cards.length
    let cents = 0
    cards.forEach((c) => { cents += parseInt(c.dataset.amountCents || '0', 10) })
    const totalEl = lane.querySelector('[data-forecast-total]')
    if (totalEl) totalEl.textContent = this.compactMoney(cents / 100)
  }

  // Mirrors CrmHelper#crm_compact_money, so a drop does not reformat the total the server rendered.
  compactMoney(value) {
    if (Math.abs(value) >= 1000000) return `${(value / 1000000).toFixed(1).replace('.', ',')} M€`
    if (Math.abs(value) >= 1000) return `${Math.round(value / 1000)} k€`
    return `${Math.round(value)} €`
  }

  headers() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return {
      'Content-Type': 'application/json',
      'X-CSRF-Token': token ? token.content : '',
      Accept: 'application/json'
    }
  }
}
